const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type AdjustmentItem = {
  id: number;
  category: 'plus' | 'minus';
  item: string;
  unitPoint: number;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchAdjustmentItemList() {
  const response = await fetch(`${apiBaseUrl}/api/admin/adjustment-items`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: AdjustmentItem[] };
  return payload.items;
}

export async function replaceAdjustmentItemList(input: {
  items: {
    id?: number;
    category: 'plus' | 'minus';
    item: string;
    unitPoint: number;
  }[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/adjustment-items`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { items: AdjustmentItem[] };
  return payload.items;
}
